const bgcolors = [
{
    label: "Background Color",
    name: "backgroundColor",
    widget: "select" ,
    default: "bg-base-200",
    required: false,
    i18n: true,
    options: [
        "bg-transparent",
        "bg-base-100",
        "bg-base-200",
        "bg-base-300",
        "bg-primary",
        "bg-primary-focus",
        "bg-primary-content",
        "bg-secondary",
        "bg-secondary-focus",
        "bg-secondary-content",
        "bg-accent",
        "bg-accent-content",
        "bg-neutral",
        "bg-neutral-content",
        "bg-alt-100",
        "bg-alt-200",
        "bg-alt-300",
        "bg-alt-400",
        "bg-alt-500",
        "bg-alt-600",
        "bg-info",
        "bg-success",
        "bg-warning",
        "bg-error" ]
    },
    {
        label: "Header Color",
        name: "headerColor",
        widget: "select" ,
        default: "text-content-base",
        required: false,
        i18n: true,
        options: [
            "text-white",
            "text-primary",
            "text-primary-content",
            "text-secondary",
            "text-secondary-content",
            "text-accent",
            "text-accent-content",
            "text-info",
            "text-info-content",
            "text-neutral" ,
            "text-neutral-content" ,
            "text-base",
            "text-base-content",
            "text-alt-100",
            "text-alt-200",
            "text-alt-300",
            "text-alt-400",
            "text-alt-500",
            "text-alt-600",
            "text-alt-700",
            "text-alt-800",
            "text-alt-900"
        ]
    },
    {
        label: "Text Color",
        name: "textColor",
        widget: "select" ,
        default: "text-content-base",
        required: false,
        i18n: true,
        options: [
            "text-white",
            "text-primary",
            "text-primary-content",
            "text-secondary",
            "text-secondary-content",
            "text-accent",
            "text-accent-content",
            "text-info",
            "text-info-content",
            "text-neutral" ,
            "text-neutral-content" ,
            "text-base",
            "text-base-content",
            "text-alt-100",
            "text-alt-200",
            "text-alt-300",
            "text-alt-400",
            "text-alt-500",
            "text-alt-600",
            "text-alt-700",
            "text-alt-800",
            "text-alt-900"
        ]
    },
    {
        label: "Background",
        name: "background",
        widget: "image",
        media_folder: "/site/assets/images/",
        public_folder: "/images/",
        i18n: true,
        required: false
    },
    {
        label: "Block Icon",
        name: "block_icon",
        media_folder: "/site/assets/images/",
        public_folder: "/images/",
        widget: "image",
        i18n: true,
        required: false
    },
    {label: "backgroundOverlay", name: "Fade out background image", widget: "boolean", default: false, required: false, i18n: true},
]

export default bgcolors;
